import React from "react";
import config from "../../../config";
import { ApiHandlerPureComponent } from "./ApiHandlerPureComponent";
import {
  ReusableCustomQuestionGroup,
  NewReusableCustomQuestionGroup,
  EditableReusableCustomQuestionGroup,
} from "../interfaces/ReusableCustomQuestionGroup";
import { handleResponseArray } from "./APIHandlerHelper";
import {
  EditableReusableCustomQuestion,
  NewReusableCustomQuestionField,
  ReusableCustomQuestionField,
} from "../interfaces/ReusableCustomQuestionField";

interface Props {
  onAuthError?: () => void;
}

export default class CustomWorkflowQuestionApis extends React.PureComponent<Props> {
  private static readonly QUESTION_FIELD_BASE_URL: string = `${config.apiGateway.WORK_API}/api/CustomWorkflowQuestion`;
  private static readonly QUESTION_GROUP_BASE_URL: string = `${config.apiGateway.WORK_API}/api/CustomWorkflowQuestion/group`;
  private apiResponseHandler = new ApiHandlerPureComponent({
    onAuthError: this.props.onAuthError,
  });

  //Question Field functions
  getCustomQuestionsByCustomer = (customerId: number): Promise<ReusableCustomQuestionField[]> => {
    const apiAddress = `${CustomWorkflowQuestionApis.QUESTION_FIELD_BASE_URL}/Customer/${customerId}`;

    return this.apiResponseHandler.get(apiAddress).then((data) => handleResponseArray(data));
  };

  createCustomQuestionField = async (customQuestionField: NewReusableCustomQuestionField): Promise<number> => {
    const apiAddress = CustomWorkflowQuestionApis.QUESTION_FIELD_BASE_URL;

    return this.apiResponseHandler.post(apiAddress, JSON.stringify(customQuestionField), false);
  };

  updateCustomQuestionField = async (customQuestionField: EditableReusableCustomQuestion): Promise<number> => {
    const apiAddress = CustomWorkflowQuestionApis.QUESTION_FIELD_BASE_URL;

    return this.apiResponseHandler.put(apiAddress, JSON.stringify(customQuestionField), false);
  };

  deleteCustomQuestionField = async (id: number): Promise<number> => {
    const apiAddress = `${CustomWorkflowQuestionApis.QUESTION_FIELD_BASE_URL}/${id}`;

    return this.apiResponseHandler.delete(apiAddress);
  };

  // Question Group functions
  getCustomQuestionGroupsByCustomer = (customerId: number): Promise<ReusableCustomQuestionGroup[]> => {
    const apiAddress = `${CustomWorkflowQuestionApis.QUESTION_GROUP_BASE_URL}/Customer/${customerId}`;

    return this.apiResponseHandler.get(apiAddress).then((data) => handleResponseArray(data));
  };

  createCustomQuestionGroup = async (customQuestionGroup: NewReusableCustomQuestionGroup): Promise<number> => {
    const apiAddress = `${CustomWorkflowQuestionApis.QUESTION_GROUP_BASE_URL}`;

    return this.apiResponseHandler.post(apiAddress, JSON.stringify(customQuestionGroup), false);
  };

  updateCustomQuestionGroup = async (customQuestionField: EditableReusableCustomQuestionGroup): Promise<number> => {
    const apiAddress = CustomWorkflowQuestionApis.QUESTION_GROUP_BASE_URL;

    return this.apiResponseHandler.put(apiAddress, JSON.stringify(customQuestionField), false);
  };

  deleteCustomQuestionGroup = async (id: number): Promise<number> => {
    const apiAddress = `${CustomWorkflowQuestionApis.QUESTION_GROUP_BASE_URL}/${id}`;

    return this.apiResponseHandler.delete(apiAddress);
  };
}
